/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Checkpoint_Restore_TitleInputs */



/**
* | output |
* | --- |
* | "Restore the project to how it was before this message" |
*
* @param {Assistant_Checkpoint_Restore_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_checkpoint_restore_title = /** @type {((inputs?: Assistant_Checkpoint_Restore_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Checkpoint_Restore_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurez le projet à son état antérieur à ce message.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stellen Sie das Projekt auf den Zustand vor dieser Nachricht wieder her.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina il progetto allo stato precedente a questo messaggio.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановите проект в том состоянии, в котором он находился до этого сообщения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaure el proyecto a como estaba antes de este mensaje.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请将项目恢复到收到此消息之前的状态。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このメッセージが表示される前の状態にプロジェクトを復元します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस संदेश से पहले प्रोजेक्ट जिस स्थिति में था, उसे पुनर्स्थापित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaure o projeto ao estado em que se encontrava antes desta mensagem.")
	return /** @type {LocalizedString} */ ("Restore the project to how it was before this message")
});